import React from "react";

import { useEffect, useState } from "react";
import {
  getDocument,
  getOneGcaApplicationDetail,
} from "../../auth/services/privateapicalling";
import { useSelector } from "react-redux";
import PdfLoader from "../pdfloader";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import PdfLoaderModal from "../pdfloader";
import SingleDocumentView from "../pdfloader/SingleDocumentView";
import RectificationOnResjection from "./RectificationOnRejection";
import useCommonServices from "../../../hooks/useCommonServices";
// import SingleView1 from "../pdfloader/Singleview1";
import ApplicationPreview from "./ApplicationPreview";

interface ApplicationDetails {
  applicantName: string;

  registeredWithAPMC: string;

  licenseType: string;
  apmcName: string;
}

interface AddressData {
  at: string;
  post: string;
  taluka: string;
  district: string;
}
interface UserAddress {
  address: string;
  post: string;
  taluka: string;
  district: string;
}

interface OfficeAddress {
  address: string;
  post: string;
  taluka: string;
  district: string;
}

interface OfficeDetails {
  panCardNo: string;
  electionCardNo: string;
  registeredEmail: string;
  mobileNo: string;
}
interface Representative {
  id: number;
  name: string;
  age: number;
  address: string;
}
interface Director {
  id: number;
  name: string;
  age: number;
  address: string;
}

interface Address {
  at: string;
  taluka: string;
  district: string;
}

interface Document {
  docId: string;
  docName: string;
  fileName: string;
  apmcName: string;
}

interface ApplicationDetails {
  apmcName: string;
  appliedDate: string;
  departmentId: string;
  department: Department;
  applicantName: string;
  currAddress: Address[];
  perAddress: Address[];
  regOffAddress: Address[];
  panCardNo: string;
  electionCardNo: string;
  regEmailId: string;
  mobileNo: string;
  representatives: any[];
  firmRepresentatives: any[];
  TraderAppTransaction:any[];
  GCAAppTransaction?: any[]; // Added missing property
  entityName:string;
  entityRegistrationNo:string;
  entityGstNo:string;
  entityType:string;
  entityPanNo:string;
  entityFpoNo:string;
  partnerDetails:any[];
  guarantorDetails: any[];
  bankDetails?: any[]; // Added missing property
  applicationId: string;
  createdAt: string;
  docs: Document[];
  status: string;
  paymentStatus: string;
  garantorDeclaration?: any; // Added property
}
interface Department {
  apmcName: string;
  Department_Name: string;
  Address: string;
  Pin_Code: number;
  Taluka: string;
  District: string;
  district_id: string;
}

const PreviewGca: React.FC = () => {
  const { applicationId } = useParams<{ applicationId: string }>();

  const [application, setApplication] = useState<ApplicationDetails | null>(
    null
  );

  const { doPayment } = useCommonServices();
  const [selectedDocId, setSelectedDocId] = useState<string | null>(null);
  const [addressData, setAddressData] = useState<AddressData | null>(null);

  const [comment, setComment] = useState<string>("");
  // const [status , setStatus] = useState<string>("");
  // const [appStatusLevel , setAppStatusLevel] = useState<string>("");
  const [role, setRole] = useState<string>("");
  const [buttonData, setButtonData] = useState<any[]>([]);
  const [transaction, setTransaction] = useState<any[]>([]);
  const [rejectedDocs, setRejectedDocs] = useState<any[]>([]);
  const [rejectedFields, setRejectedFields] = useState<any[]>([]);
  const { downloadLicense } = useCommonServices();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const [uploadedFiles, setUploadedFiles] = useState<Record<string, string>>(
    {}
  );
  const [htmlContent, setHtmlContent] = useState<string>("");
  const [downloadapplication, setDownloadApplication] = useState<any[] | null>(
    null
  );

  const language = useSelector((state: any) => state.auth.language);
  const token = useSelector((state: any) => state.auth.token);
  const roleIdentifier = useSelector(
    (state: any) => state.auth.userDetails?.Role?.Role_Identifier
  );
  //.log("rolee iddd redux", roleIdentifier);
  // const location = useLocation();
  // const applicationId = location.state?.applicationId;

  const navigate = useNavigate()

  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
    type: string
  ) => {
    const file = e.target.files?.[0];
    if (file) {
      setUploadedFiles((prev) => ({
        ...prev,
        [`${index}-${type}`]: URL.createObjectURL(file),
      }));
    }
  };


  const fetchApplicationDetails = async (appId: any) => {
    try {
  
      const data = await getOneGcaApplicationDetail(appId, token);
      //.log("datdatadataa", data);
      if(!data?.success){
        navigate("/error-404")
       }
     

      setApplication(data.data);
      setDownloadApplication(data.data);
      setButtonData(data.data.buttonName);
      setRole(data.data?.role);

      const application = data?.data;

      const rejectedDocs = application?.rejectedDocName;
      const rejectedFields = application?.rejectedFieldName;
      //.log("resubrejjjj fields docs", rejectedFields, rejectedDocs);
      setRejectedDocs(rejectedDocs);
      setRejectedFields(rejectedFields);
      //.log("rejecteddd docss and fields", rejectedDocs, rejectedFields);

      const app = data.data;
      const curradd = app.currAddress;
      //.log("ccc", curradd);
      setAddressData(curradd);
    } catch (err) {
      setError("Failed to load application details");
    } finally {
      setLoading(false);
      //.log("apppp", application);
    }
  };

  const handlePayment = async () => {
    //.log("Payment button clicked");

    const res = await doPayment(applicationId);
    //.log("resss", res.data);

    const htmlText = await res.data.text();

    // Create a temporary container for the form
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlText;

    // Find the form inside the response
    const form = tempDiv.querySelector(
      'form[name="pgposting"]'
    ) as HTMLFormElement;

    if (form) {
      document.body.appendChild(form); // Append the form to the body (hidden)
      //.log("Submitting form...");
      form.submit();
    } else {
      //.error("Form not found in response!");
    }
  };

  const handleDownload = async () => {
    try {
      const licenseRes = await downloadLicense(applicationId);
      //.log("licenseRes", licenseRes);

      const url = window.URL.createObjectURL(licenseRes);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `license-${applicationId}.pdf`); // Suggested file name
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      //.log("error", error);
    }
  };
  // const submitForm = () => {

  //   const form = document.querySelector('form[name="pgposting"]') as HTMLFormElement;
  //   if (form) {
  //     //.log("Submitting form...");
  //     form.submit();
  //   }
  // };

  useEffect(() => {
    //.log("pppppppppp");

    //.log("param id", applicationId);

    fetchApplicationDetails(applicationId);
    // fetchTraderApplicationButton();
  }, []);
  //.log("ttttttttttttttt", application);

  const handleDraftApplication = () => {
    navigate("/gca-license-registration-form");
  };

  const formatDateTime = (dateTime: string): string => {
    const date = new Date(dateTime);
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
      // hour: "numeric",
      // minute: "numeric",
      // hour12: true,
    };
    return date.toLocaleString("en-US", options);
  };



  let dateTime =
    application && application?.appliedDate
      ? formatDateTime(application?.appliedDate)
      : "";

  return (
    <>
      <div>
        <div className="cardhead page-wrapper">
          <div className="content">
            <div className="">
              <h3 className="page-title">General Comission Agent Application Preview</h3>

              {application &&
                application?.status == "resubmission" &&
                (roleIdentifier === "GCA"||roleIdentifier === "Tr") &&
                applicationId &&
                token &&
                buttonData && (
                  <div className="mb-4 mt-4">
                    {rejectedFields && (
                      <RectificationOnResjection
                        rejectedDocs={rejectedDocs}
                        rejectedFields={rejectedFields}
                        applicationId={applicationId}
                        // fetchApplicationDetails={fetchApplicationDetails}
                        fetchApplicationDetails={() =>
                          fetchApplicationDetails(applicationId)
                        }
                        token={token}
                        buttonData={buttonData}
                        applicationTransaction={application?.GCAAppTransaction}

                      />
                    )}
                  </div>
                )}
            </div>
            <div className="row mt-4">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header ">
                    <div className="d-flex align-items-center justify-content-between w-100 ml-5">
                      <h5 className="card-title">{language.app_details}</h5>
                      <h5>
                        Application Status:{" "}
                        {application?.status
                          ? application.status.charAt(0).toUpperCase() +
                            application.status.slice(1)
                          : "N/A"}
                        <div className="mt-1 fs-15">
                          {" "}
                          Applied Date: {dateTime ? dateTime : "N/A"}
                        </div>
                      </h5>
                    </div>
                  </div>
                    <div className="card-body">
                    {loading ? (
                      <p>Loading application details...</p>
                    ) : error ? (
                      <p className="text-danger">{error}</p>
                    ) : (
                      <div className="table-responsive">
                        {/* First Table */}
                        <table className="table table-nowrap mb-0">
                          <thead>
                            <tr>
                              <th style={{ width: '25%' }}>{language.agentName}</th>

                              <th style={{ width: '25%' }}>{language.register_with_apmc}</th>
                              <th style={{ width: '25%' }}>{language.period_of_license}</th>
                              <th style={{ width: '25%' }}>Application ID</th>
                            </tr>
                          </thead>
                          <tbody>
                            {application ? (
                              <tr>
                                <td style={{ width: '25%' }}>{application.applicantName}</td>

                                <td style={{ width: '25%' }}>
                                  {application.department?.apmcName ?? "N/A"}
                                </td>

                                <td style={{ width: '25%' }}>{application.licenseType}</td>
                                <td style={{ width: '25%' }}>{application.applicationId}</td>
                              </tr>
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  No application details available.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                        {/* Second Table */}
                      </div>
                    )}
                  </div>
                    <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th style={{ width: '25%' }}>{language.mobile}</th>
                                <th style={{ width: '25%' }}>{language.email}</th>
                                <th style={{ width: '25%' }}>{language.pan_card_no}</th>
                                <th style={{ width: '25%' }}>{language.election_card_no}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              ) : error ? (
                                <tr>
                                  <td
                                    colSpan={4}
                                    className="text-center text-danger"
                                  >
                                    {error}
                                  </td>
                                </tr>
                              ) : !application ? ( // Check if application is null
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    No application details available.
                                  </td>
                                </tr>
                              ) : application?.currAddress.length > 0 ? (
                                <tr>
                                  <td style={{ width: '25%' }}>{application?.mobileNo}</td>
                                  {/* <td>{userAddress.post}</td> */}
                                  <td style={{ width: '25%' }}>{application?.regEmailId}</td>
                                  <td style={{ width: '25%' }}>
                                    {application?.panCardNo}
                                  </td>
                                  <td style={{ width: '25%' }}>
                                    {application?.electionCardNo}
                                  </td>
                                </tr>
                              ) : (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    No details available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <div>
                      <h5 className="mb-2">{language.current_address}:</h5>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th>{language.address}</th>
                                <th>{language.taluka}</th>
                                <th>{language.district}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={3} className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              ) : error ? (
                                <tr>
                                  <td
                                    colSpan={3}
                                    className="text-center text-danger"
                                  >
                                    {error}
                                  </td>
                                </tr>
                              ) : !application ? ( // Check if application is null
                                <tr>
                                  <td colSpan={3} className="text-center">
                                    No application details available.
                                  </td>
                                </tr>
                              ) : application?.currAddress.length > 0 ? (
                                <tr>
                                  <td>{application?.currAddress[0].at}</td>
                                  {/* <td>{userAddress.post}</td> */}
                                  <td>{application?.currAddress[0].taluka}</td>
                                  <td>
                                    {application?.currAddress[0].district}
                                  </td>
                                </tr>
                              ) : (
                                <tr>
                                  <td colSpan={3} className="text-center">
                                    No address details available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div>
                      <h5 className="mb-2"> {language.permanent_address}:</h5>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th>{language.address}</th>
                                <th>{language.taluka}</th>
                                <th>{language.district}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={3} className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              ) : error ? (
                                <tr>
                                  <td
                                    colSpan={3}
                                    className="text-center text-danger"
                                  >
                                    {error}
                                  </td>
                                </tr>
                              ) : !application ? (
                                <tr>
                                  <td colSpan={3} className="text-center">
                                    No application details available.
                                  </td>
                                </tr>
                              ) : application?.perAddress.length > 0 ? (
                                <tr>
                                  <td>{application?.perAddress[0].at}</td>
                                  {/* <td>{userAddress.post}</td> */}
                                  <td>{application?.perAddress[0].taluka}</td>
                                  <td>{application?.perAddress[0].district}</td>
                                </tr>
                              ) : (
                                <tr>
                                  <td colSpan={3} className="text-center">
                                    No address details available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div>
                      <h5 className="mb-2">
                        {language.registered_office_address}:
                      </h5>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th>{language.address}</th>
                                <th>{language.taluka}</th>
                                <th>{language.district}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={3} className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              ) : error ? (
                                <tr>
                                  <td
                                    colSpan={3}
                                    className="text-center text-danger"
                                  >
                                    {error}
                                  </td>
                                </tr>
                              ) : !application ? ( // Check if application is null
                                <tr>
                                  <td colSpan={3} className="text-center">
                                    No application details available.
                                  </td>
                                </tr>
                              ) : application?.regOffAddress.length > 0 ? (
                                <tr>
                                  <td>{application?.regOffAddress[0].at}</td>
                                  {/* <td>{userAddress.post}</td> */}
                                  <td>
                                    {application?.regOffAddress[0].taluka}
                                  </td>
                                  <td>
                                    {application?.regOffAddress[0].district}
                                  </td>
                                </tr>
                              ) : (
                                <tr>
                                  <td colSpan={3} className="text-center">
                                    No address details available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
  <div>
                      <h5 className="mb-2">{language.bankDetails}:</h5>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th>Sr No.</th>
                                <th>{language.acct_no}</th>
                                <th>{language.ifsc_code}</th>
                                <th>{language.acct_type}</th>
                                  <th>{language.bank_name}</th>
                                <th>{language.branch_name}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              ) : error ? (
                                <tr>
                                  <td
                                    colSpan={4}
                                    className="text-center text-danger"
                                  >
                                    {error}
                                  </td>
                                </tr>
                              ) : !application ? ( // Check if application is null
                                <tr>
                                  <td colSpan={3} className="text-center">
                                    No application details available.
                                  </td>
                                </tr>
                              ) : application?.bankDetails?.length > 0 ? (
                                application?.bankDetails?.map(
                                  (rep, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}.</td>
                                      <td>{rep?.acct_no}</td>
                                      <td>{rep?.ifsc_code}</td>
                                      <td>{rep?.acct_type}</td>
                                      <td>{rep?.bank_name}</td>
                                      <td>{rep?.branch_name}</td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    No Bank Details available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div>
                      <h5 className="mb-2">{language.representative}:</h5>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th>Sr No.</th>
                                <th>{language.name}</th>
                                <th>{language.age_in_year}</th>
                                <th>{language.address}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              ) : error ? (
                                <tr>
                                  <td
                                    colSpan={4}
                                    className="text-center text-danger"
                                  >
                                    {error}
                                  </td>
                                </tr>
                              ) : !application ? ( // Check if application is null
                                <tr>
                                  <td colSpan={3} className="text-center">
                                    No application details available.
                                  </td>
                                </tr>
                              ) : application.representatives.length > 0 ? (
                                application.representatives.map(
                                  (rep, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}.</td>
                                      <td>{rep.name}</td>
                                      <td>{rep.age}</td>
                                      <td>{rep.address}</td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    No representatives available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div>
                      <h5 className="mb-2">{language.firm}:</h5>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th>Sr No.</th>
                                <th>{language.name}</th>
                                <th>{language.age_in_year}</th>
                                <th>{language.address}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              ) : error ? (
                                <tr>
                                  <td
                                    colSpan={4}
                                    className="text-center text-danger"
                                  >
                                    {error}
                                  </td>
                                </tr>
                              ) : !application ? ( // Check if application is null
                                <tr>
                                  <td colSpan={3} className="text-center">
                                    No application details available. 
                                  </td>
                                </tr>
                              ) : application?.partnerDetails?.length > 0 ? (
                                application?.partnerDetails.map(
                                  (director, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}.</td>
                                      <td>{director.partnerName}</td>
                                      <td>{director.partnerAge}</td>
                                      <td>{director.partnerAddress}</td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    No firm/partner available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div>
                      <h5 className="mb-2">{language.firmDetails}:</h5>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th>Firm Name</th>
                                <th>Firm Registration No.</th>
                                <th>Firm Type</th>
                                <th>GST No.</th>
                                <th>Pan No</th>
                                <th>FPO  No</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              ) : error ? (
                                <tr>
                                  <td
                                    colSpan={4}
                                    className="text-center text-danger"
                                  >
                                    {error}
                                  </td>
                                </tr>
                              ) : !application ? ( // Check if application is null
                                <tr>
                                  <td colSpan={3} className="text-center">
                                    No application details available. 
                                  </td>
                                </tr>
                              ) :  application?.entityName ? (
                               
                                      <tr>
                                      <td>{application?.entityName}</td>
                                      <td>{application?.entityRegistrationNo}</td>
                                      <td>{application?.entityType}</td>
                                      <td>{application?.entityGstNo}</td>
                                      <td>{application?.entityPanNo}</td>
                                      <td>{application?.entityFpoNo}</td>
                                    </tr>
                                  
                                
                              ) : (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    No firm Details available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div>
                      <h5 className="mb-2">{language.enclosure}:</h5>
                      <div className="card-body">
                        <div className="table-responsive">
                          <i className="text-2xl text-red-600 fa fa-file-pdf"></i>

                          <Link
                            to="#"
                            className="text-decoration-underline text-primary me-2"
                            data-bs-toggle="modal"
                            data-inert={true}
                            data-bs-target="#pdf_loader_modal"
                          >
                            {language.preview}
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="">
                      <h5 className="mb-2">{language.guarantor}:</h5>
                      <div className="card-body">
                        <div className="table-responsive mb-4">
                          <table className="table text-nowrap">
                            <thead>
                              <tr>
                                <th>Sr No.</th>
                                <th>{language.name}</th>
                                <th>{language.address}</th>
                                <th>{language.pan_card_no}</th>
                                <th>{language.photo}</th>
                                <th>{language.Signature}</th>
                                <th>{language.declarations}</th>
                              </tr>
                            </thead>
                  
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={7} className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              ) : error ? (
                                <tr>
                                  <td
                                    colSpan={7}
                                    className="text-center text-danger"
                                  >
                                    {error}
                                  </td>
                                </tr>
                              ) : !application ? (
                                <tr>
                                  <td colSpan={7} className="text-center">
                                    No application details available.
                                  </td>
                                </tr>
                              ) : application.guarantorDetails?.length > 0 ? (
                                application.guarantorDetails.map(
                                  (guarantor, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{guarantor.name}</td>
                                      <td>
                                        <span className="badge bg-soft-primary">
                                          {guarantor.address}
                                        </span>
                                      </td>
                                      <td>{guarantor.panCardNo}</td>
                                      {["photo", "signature", "declaration"].map((type) => (
                                      <td key={type}>
                                        {type === "declaration" ? (
                                          // For declaration, use application.guarantorDeclaration
                                          application?.garantorDeclaration ? (
                                            <Link
                                              to="#"
                                              data-bs-toggle="modal"
                                              data-inert={true}
                                              data-bs-target="#single_doc_modal"
                                              className="btn btn-primary align-items-center"
                                              onClick={() => {
                                                
                                                setSelectedDocId(application?.garantorDeclaration?.docId);
                                               
                                              }}
                                            >
                                              {language.preview}
                                            </Link>
                                          ) : (
                                            "No Attachment"
                                          )
                                        ) : (
                                          // For photo or signature from docDetail
                                          Array.isArray(guarantor.docDetail) &&
                                          guarantor.docDetail.length > 0 ? (
                                            (() => {
                                              const docType = type === "photo" ? `guarantorPhoto_${index + 1}` : `guarantorSignature_${index + 1}`;
                                              const doc = guarantor.docDetail.find((d) =>
                                                d.documentName?.includes(docType)
                                              );

                                              return doc ? (
                                                <Link
                                                  to="#"
                                                  data-bs-toggle="modal"
                                                  data-inert={true}
                                                  data-bs-target="#single_doc_modal"
                                                  className="btn btn-primary align-items-center"
                                                  onClick={() => {
                                                    setSelectedDocId(doc.docId);
                                                   
                                                  }}
                                                >
                                                  {language.preview}
                                                </Link>
                                              ) : (
                                                "No Attachment"
                                              );
                                            })()
                                          ) : (
                                            "No Attachment"
                                          )
                                        )}
                                      </td>
                                    ))}

                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan={7} className="text-center">
                                    No guarantor details available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                    

                        {application && application.status == "draft" && (
                      <div className="d-flex justify-content-between p-4 w-50">
                        <button
                          className="btn btn-success"
                          onClick={handleDraftApplication}
                        >
                          {language.complete}
                        </button>
                      </div>
                    )}

                        <div className="row p-3">
                          {application && application.status == "approve" && (
                            <div className="col-sm-12 d-flex justify-content-end">
                              {/* <button
                                onClick={() => {
                                  handleDownload();
                                }}
                                className="bg-success rounded text-white px-4 py-2"
                              >
                                {language.download_license}
                              </button> */}

                               {(() => {
                                const latestLicense = application?.docs
                                  .filter((doc: any) =>
                                    doc.documentName.toLowerCase().includes("license")
                                  )
                                  .at(-1); // Get the last license

                                return latestLicense ? (
                                  <Link
                                    key={latestLicense?.docId}
                                    to="#"
                                    data-bs-toggle="modal"
                                    data-inert={true}
                                    data-bs-target="#single_doc_modal"
                                    className="btn btn-success align-items-center"
                                    onClick={() => setSelectedDocId(latestLicense?.docId)}
                                  >
                                    {language.download_license}
                                  </Link>
                                ) : null;
                              })()}
                            </div>
                          )}
                        </div>
                        { <ApplicationPreview downloadapplication={downloadapplication} />}
                      </div>
                      <div className="d-flex row justify-content-center">
                        <div className="d-flex justify-content-between w-50">
                          {/* <button className="btn btn-warning">Modify</button> */}
                          {application &&
                            application.paymentStatus == "PENDING" &&
                            application.status == "pending" && (
                              <button
                                className="btn btn-success"
                                onClick={handlePayment}
                              >
                                {language.ptp}
                              </button>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PdfLoaderModal
        applicationId={applicationId ?? ""}
        applicationType="gca"
      />
      <SingleDocumentView docId={selectedDocId} />
    </>
  );
};

export default PreviewGca;
